module.exports = __webpack_public_path__ + "img/qrCode_en.93659e97.png";